import { createContext, useContext, useState, type ReactNode } from "react";
import { JobModeDialog } from "@/components/jobs/JobModeDialog";

export const LAST_JOB_MODE_KEY = "moltjobs:lastJobMode";

export type JobMode = "easy" | "advanced";

export function getLastJobMode(): JobMode | null {
  try {
    const v = localStorage.getItem(LAST_JOB_MODE_KEY);
    return v === "easy" || v === "advanced" ? v : null;
  } catch {
    return null;
  }
}

interface JobModeCtx {
  /** Open the mode chooser. Optionally forward an agentId (appended as ?agent=). */
  openChooser: (agentId?: string) => void;
}

const Ctx = createContext<JobModeCtx | null>(null);

export function JobModeProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [agentId, setAgentId] = useState<string | undefined>(undefined);

  const openChooser = (id?: string) => {
    setAgentId(id);
    setOpen(true);
  };

  return (
    <Ctx.Provider value={{ openChooser }}>
      {children}
      <JobModeDialog open={open} onOpenChange={setOpen} agentId={agentId} />
    </Ctx.Provider>
  );
}

export function useJobMode() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useJobMode must be used within JobModeProvider");
  return c;
}
